// extracted by mini-css-extract-plugin
export default {"root":"GoldPageRoot_root__qW3bg","inner":"GoldPageRoot_inner__cmMyt"};